<template>
    <div>
        <BasicDialog @close="closeDialog">
            <v-row>



                <v-col cols="12" class="d-flex flex-row justify-center align-center">
                    <logo-background></logo-background>
                    <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
                        <img :src="AppConfigs.staticImages.FOLLOWONINSTAGRAM" alt="Follow us on Instagram" style="width: 70%; height: auto; transform: scale(0.5)">
                        <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable" style="position: absolute; top: 3%; left: 23%;">
                    </div>
                </v-col>




                <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
                    Follow on Instagram 
                </v-col>




                <v-col cols="12" class="text-center">
                    Follow us on Instagram and earn {{ coinsForFollowingOnInstagram }} coins
                </v-col>

                


                <v-col cols="12" class="d-flex flex-row justify-center">
                    <v-btn rounded="pill"
                        :disabled="!isAvailable"
                        class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
                        @click="followOnInstagram">
                        Follow Now
                    </v-btn>
                </v-col>




            </v-row>
        </BasicDialog>
    </div>
</template>



<script>

import { defineComponent } from 'vue';
import { AppConfigs } from "@/app.configs";
import { computed, inject, provide } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';

import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";


export default defineComponent({
    name: 'FollowOnInstagramDialog',
    components: {
        BasicDialog,
        LogoBackground,
    },
    setup(props, { emit }) {
        let openDialog = inject('inHouseTaskOpenDialog');
        provide('openDialog', openDialog);
        const inHouseTaskStore = UserActivityStore();
        const coinsForFollowingOnInstagram = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
        const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);
        
        
        function closeDialog() {
            emit('close');
        }

        function followOnInstagram() {
            const instagramProfileUrl = 'https://www.instagram.com/bountyhunterapp/';
            window.open(instagramProfileUrl, '_blank');
            inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
        }

        return {
            AppConfigs,
            closeDialog,
            isAvailable,
            followOnInstagram,
            coinsForFollowingOnInstagram,
        };
    },
});
</script>